import React from 'react';
import { connect } from 'react-redux';
import { ContentGroup } from 'ui';
import { featuredContentsSelector } from 'selectors/learn/contents';
import { createCompoundId } from 'selectors/learn/helpers';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import ContentCard from '../../shared/LearnContentCard';

const trackClickEvent =
  ({ id, type }) =>
  () => {
    const eventTrackingData = {
      browser_information: true,
      event_type: 'featured_content/featured_content_clicked',
      event_data: { content_id: id, content_type: type },
    };
    request.post(routes.EVENTS, eventTrackingData);
  };

const FeaturedContent = ({ featuredContent, isOnlySection }) => (
  <ContentGroup
    className="LearnContentGroup"
    title={t('content.groups.featured')}
    items={featuredContent}
  >
    <ContentGroup.Items
      render={assignment => (
        <ContentCard
          onClick={trackClickEvent(assignment)}
          key={createCompoundId(assignment)}
          {...assignment}
        />
      )}
    />
  </ContentGroup>
);

const mapStateToProps = state => ({
  featuredContent: featuredContentsSelector(state),
});

export default connect(mapStateToProps)(FeaturedContent);
